import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {EditPermissions} from '../../../../../../../../../shared/models';
import {isNumber, maximumCount, required} from '../../../../../../../../../shared/utils';

interface InputPage {
  pageType: 'inputPage';
  order?: number;
  pageHeader: string;
  pageSubHeader: string;
  regex: string;
  placeHolder: string;
  inputType: 'multiline' | 'singleline';
  labelText: string;
  prefixText: string;
  maximumCharacterCount: number;
  keyboardType: string;
  required: boolean;
}

@Component({
  selector: 'input-page',
  templateUrl: './input-page.component.html',
  styleUrls: ['../styles.scss', './input-page.component.scss']
})
export class InputPageComponent implements OnInit, OnDestroy {
  constructor() {}

  @Input() pageData: any;
  @Input() canEdit: EditPermissions;
  @Output() setPageData = new EventEmitter();
  moreInfoOpened = false;

  inputPageForm: FormGroup;

  ngOnInit() {
    this.inputPageForm = this.getInputPageTemplate();

    const { page, newPage } = this.pageData;
    this.inputPageForm.patchValue(page);

    if (newPage === false) {
      this.inputPageForm.markAllAsTouched();
    }

    this.setPageDataHandler();
    this.listenForFormChanges();
  }

  ngOnDestroy() {
    this.setPageDataHandler();
  }

  getInputPageTemplate() {
    return new FormGroup({
      pageHeader: new FormControl({
        value: '',
        disabled: !this.canEdit
      }),
      pageSubHeader: new FormControl({
            value: '',
            disabled: !this.canEdit
          }, [required('Subheader')]),
      regex: new FormControl({
        value: '',
        disabled: !this.canEdit
      }),
      placeHolder: new FormControl({
        value: '',
        disabled: !this.canEdit
      }, [required('Placeholder')]),
      inputType: new FormControl({
        value: '',
        disabled: !this.canEdit
      }),
      labelText: new FormControl({
        value: '',
        disabled: !this.canEdit
      }),
      prefixText: new FormControl({
        value: '',
        disabled: !this.canEdit
      }),
      maximumCharacterCount: new FormControl({
        value: '',
        disabled: !this.canEdit
      }, [maximumCount(300, 'Character count'), isNumber('maximumCharacterCount')]),
      keyboardType: new FormControl({
        value: '',
        disabled: !this.canEdit
      }),
      required: new FormControl({
        value: false,
        disabled: !this.canEdit
      })
    });
  }

  setPageDataHandler() {
    const data = {
      ...this.pageData,
      page: this.getData()
    };
    this.setPageData.emit(data);
  }

  listenForFormChanges() {
    this.inputPageForm.valueChanges.subscribe(values => {
      this.setPageDataHandler();
    });
  }

  getData() {
    const pageFormValues = this.inputPageForm.getRawValue();
    return {
      ...pageFormValues,
      pageType: this.pageData.type,
      valid: this.inputPageForm.valid
    };
  }

  openMoreInfo() {
    this.moreInfoOpened = true;
  }

  closeMoreInfo() {
    this.moreInfoOpened = false;
  }
}
